'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var contentClasses = {
  noImage: 'col-lg-offset-2 col-lg-8',
  useImage: 'social-proof__column text-lg-left col-lg-offset-0',
  defaultClasses: ' social-proof__quote-container col-lg-7 text-xs-center col-xs-10 col-xs-offset-1'
};
var getContentClasses = function getContentClasses(useImage) {
  return (useImage ? contentClasses.useImage : contentClasses.noImage) + contentClasses.defaultClasses;
};

var renderBackgroundImage = function renderBackgroundImage(backgroundImage) {
  if (backgroundImage && backgroundImage.url) {
    return _react2.default.createElement(
      'div',
      {
        className: 'social-proof__column social-proof__image-container col-lg-3 col-lg-offset-1 col-xs-12'
      },
      _react2.default.createElement('div', {
        className: 'social-proof__square-container',
        style: { backgroundImage: 'url(' + backgroundImage.url + ')' }
      })
    );
  }
  return null;
};
var renderQuoteText = function renderQuoteText(quote) {
  if (quote) {
    return _react2.default.createElement(
      _heading2.default,
      { level: '2', className: 'h3' },
      _react2.default.createElement(
        'blockquote',
        { className: 'social-proof__quote' },
        htmlToReactParser.parse(quote.text)
      )
    );
  }
  return null;
};

var renderReference = function renderReference(citation, type) {
  if (citation) {
    var referenceClassnames = (0, _classnames2.default)('social-proof__reference pp-sans-small-medium', {
      'social-proof__reference--social social-proof__reference--facebook': type === 'facebook',
      'social-proof__reference--social social-proof__reference--twitter': type === 'twitter'
    });
    return _react2.default.createElement(
      'p',
      { className: referenceClassnames },
      htmlToReactParser.parse(citation.text)
    );
  }
  return null;
};

var SocialProofItem = function SocialProofItem(props) {
  var content = props.content,
      config = props.config,
      className = props.className,
      showImages = props.showImages;
  var quote = content.quote,
      citation = content.citation,
      backgroundImage = content.backgroundImage;
  var id = config.id,
      theme = config.theme,
      type = config.type;


  var socialProofClasses = (0, _classnames2.default)('social-proof', theme, className);
  var shouldUseImage = type === 'image' && backgroundImage;
  var contentClassname = getContentClasses(shouldUseImage);

  return _react2.default.createElement(
    'section',
    { className: socialProofClasses, id: id, 'data-building-block': 'organism' },
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'div',
        { className: 'row' },
        showImages && shouldUseImage && renderBackgroundImage(backgroundImage),
        _react2.default.createElement(
          'div',
          { className: contentClassname },
          renderQuoteText(quote),
          renderReference(citation, type)
        )
      )
    )
  );
};

exports.default = SocialProofItem;

/* Default content */

SocialProofItem.propTypes = {
  config: _propTypes2.default.shape({
    theme: _propTypes2.default.oneOf(['theme-background-color-blue', 'theme-background-color-light', 'theme-background-color-white']).isRequired,
    type: _propTypes2.default.oneOf(['image', 'no-image', 'facebook', 'twitter']).isRequired,
    id: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    backgroundImage: _propTypes2.default.shape({
      url: _propTypes2.default.string.isRequired
    }),
    quote: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    socialProofReference: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  className: _propTypes2.default.string,
  showImages: _propTypes2.default.bool
};

SocialProofItem.defaultProps = {
  config: {
    theme: 'theme-background-color-white',
    type: 'image',
    id: ''
  },
  content: {
    backgroundImage: {
      url: 'https://www.paypalobjects.com/digitalassets/c/website/icons/social/social-image-vertical.jpg'
    },
    quote: {
      text: '“125 characters maximum with <a href="https://www.paypal.com" target="blank"' + ' data-pa-click="SclPrf-link-hashtag" >#Hashtags</a> linked and tracked with the' + ' associated data-pa-click parameters within anchor tags.”'
    },
    citation: {
      text: ' 57 characters maximum or 2 lines on mobile'
    }
  },
  className: '',
  showImages: true
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/social-proof/jsx/SocialProofItem.js
// module id = 1145
// module chunks = 4